import { createStore, applyMiddleware, compose, Middleware } from "redux"
import reducers from "./reducers"
import thunk from "redux-thunk"
import { createLogger } from "redux-logger"

const middleware: Middleware[] = [thunk]

if (process.env.NODE_ENV !== "production") {
  middleware.push(createLogger())
}

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  (typeof window === "object" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose
/* eslint-enable */

export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(...middleware))
)

export default store
